module.exports = __webpack_public_path__ + "img/noresults.2d0b9c55.svg";